import React from 'react'
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { DateCellStyling,ContainerStyling,HeadingStyling,ContentCellStyling,TableStyling,TableRowStyling } from './BiogTableStyles';

export default function BiogTeaching() {
  const { t } = useTranslation('common');

  return (
    <Grid2 flexDirection="row" sx={ContainerStyling}>
        <TableContainer>
          <Table sx={TableStyling} aria-label="simple table">
            <TableBody>
              <TableRow
                key={"1"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                2001
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Dozentin"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Lehrer/innen Fortbildung Basel-Stadt</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"2"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1999
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Vorlesung"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Universität Basel, Basel</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"3"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1997-02
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Dozentin"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Volkshochschule beider Basel, Basel</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"4"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1995
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Gastdozentin"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Universidade Federal de Uberlandia, Brasilien</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"5"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Lehrtätigkeit"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Freie Kunstakademie, Basel</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"6"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1989
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Künstler-Mentor"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, California College of Arts and Crafts, Oakland, CA</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"7"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1988
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Vorlesung und Workshop"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, University of Wisconsin, Oshkosh, WI</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"8"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Podiumsdiskussion"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, University of California, Berkeley, CA</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"9"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1980-82/85
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Instruktorin für Hochbauzeichner"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Gewerbeschule, Brugg</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"10"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1981
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Vorlesung"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Eidgenössische Technische Hochschule, Zürich</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"11"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Mitarbeit Symposium"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Universität Zürich, Zürich</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key={"12"}
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                1980
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>{"Podiumsdiskussion"}</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Eidgenössische Technische Hochschule, Zürich</Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
    </Grid2>
  )
}
